import { render, staticRenderFns } from "./mbot.vue?vue&type=template&id=0f1f8f3e&scoped=true"
import script from "./mbot.vue?vue&type=script&lang=js"
export * from "./mbot.vue?vue&type=script&lang=js"
import style0 from "./mbot.vue?vue&type=style&index=0&id=0f1f8f3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1f8f3e",
  null
  
)

export default component.exports